// Plan wording shown under the account name (header dropdown and the phone menu).
// Keyed by the numeric plan code the profile carries as `plan_id`
// (ezp_users.plan_type); 3 is also the code that unlocks full HRMS, Growth and
// Inventory.
const PLAN_LABELS = {
  1: "Free Plan",
  2: "Pro Plan",
  3: "Enterprise Plan",
};

// A known code always wins. For any other code, fall back to the plan's own name
// from the profile (as before), and to "Free Plan" when there is none.
export function getPlanLabel(profile) {
  const byCode = PLAN_LABELS[Number(profile?.plan_id)];
  if (byCode) return byCode;
  return profile?.plan_name ? `${profile.plan_name} Plan` : "Free Plan";
}
